<template>
    <div>
        <div v-for="(item, index) in data" :key="item.qid">
            <!-- 基本信息 -->
            <div :name="`name${index}`"  v-if="item.questionsTypeId == 600" class="list"
                :style="{
                    padding: !$functions.isPC() ? '15px 0': '30px 39px',
                }"
            >
                <div class="title">
                    <span v-html="item.questionsName"></span> : <span class="user-info-text">{{item.userResult}}</span>
                </div>
            </div>
            
            <div v-else :name="`name${index}`" class="question list"
                :style="{
                    padding: !$functions.isPC() ? '15px 0': '30px 39px',
                }"
            >
                <!-- scoringType == 3 人工评分 isPreview == 1待评分入口 -->
                <p class="label" v-if="item.scoringType == 3 && isPreview == 1">手动评分</p>
                <div class="top">
                    <!-- 单选 多选 判断 -->
                    <div class="ques-body" v-if="item.questionsTypeId == 100 || item.questionsTypeId == 101 || item.questionsTypeId == 102">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <div class="option-box">
                            <div 
                                class="option" 
                                :style="{width: item.showcolnum == 1?'100%':(item.showcolnum == 2?'50%':(item.showcolnum == 3?'30.3%':'25%'))}" 
                                v-for="(info, i) in item.optionList" 
                                :key="info.oid"
                            >
                                <span 
                                class="option-index" 
                                :class="{'option-action': item.userResult.indexOf(info.oid) != -1}">
                                {{i + 1}}.</span><span class="option-title" v-html="info.labelName"></span>
                                <div 
                                    v-if="info.haveInput"
                                    class="other-input">
                                    <el-input
                                        disabled
                                        size="mini"
                                        v-model="info.inputValue"
                                        >
                                    </el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 填空 简答 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 204 || item.questionsTypeId == 206">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <p class="user-answer">
                            {{item.userResult}}
                        </p>
                    </div>
                    <!-- 多项填空 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 207">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <div class="optionList" v-for="val in item.optionList" :key="val.oid">
                            <p class="title" v-html="val.labelName"></p>
                            <p class="user-answer-item">
                                {{val.userResult}}
                            </p>
                        </div>
                    </div>
                    <!-- 横向填空 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 208">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <template v-for="(val, index) in item.questionOption">
                            <span class="ques_content" v-if="typeof val == 'string'" v-html="val" :key="index"></span>
                            <div  v-else class="input_box ques_content" :key="index" > 
                                <input 
                                    disabled                                    
                                    :class="{'input__horizontal__err': item.optionList[val.index].validate}"
                                    v-model="item.optionList[val.index].userResult" 
                                    type="text" 
                                    :maxlength="item.optionList[val.index].maxNum"
                                    :style="`display: inline-block;width:${val.width}px;border: none;border-bottom: 1px solid;outline: none;text-align: center;`">
                            </div>
                        </template>
                    </div>
                    <!-- 绘图题 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 209">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <div class="img-box">
                            <img v-show="item.userResult" :src="item.userResult" alt="">
                            <p v-show="item.userResult == '' ">未答</p>
                        </div>
                    </div>
                    <!-- 上传文件 -->
                    <div class="ques-body" v-else-if="item.questionsTypeId == 210">
                        <p class="title">
                            {{item.quesIndex + 1}}.<span v-html="item.questionsName"></span>
                        </p>
                        <p v-if="item.userResult == ''" class="fileList-null">无文件</p>
                        <template v-else>
                            <el-button 
                                @click="exportFile(info)"
                                class="fileList-box"
                                v-for="(info, index) in item.userResult" 
                                :key="index" 
                                type="text"
                            >{{info.split(':')[2]}}</el-button>
                        </template>
                    </div>
                    <div class="result" v-if="$functions.isPC()">
                        <el-button-group v-if="item.scoringType == 3 && isPreview == 1">
                            <el-button size="small" :class="{'correct': item.isCorrect == 1}" @click="item.isCorrect = 1" type="primary">正确</el-button>
                            <el-button size="small" :class="{'error': item.isCorrect == 2}" @click="item.isCorrect = 2" type="primary">错误</el-button>
                        </el-button-group>
                        <el-button-group  v-else>
                            <el-button size="small" disabled :class="{'correct': item.isCorrect == 1}" type="primary">正确</el-button>
                            <el-button size="small" disabled :class="{'error': item.isCorrect == 2}" type="primary">错误</el-button>
                        </el-button-group>
                        <div class="score">
                            得分：
                            <el-input-number 
                                v-if="isPreview == 1" 
                                :disabled="item.scoringType != 3"
                                class="input" 
                                @change="userGetScoreInput(item)" 
                                v-model="item.userGetScoreValue" 
                                size="small" 
                                :min="0"
                                :max="item.score"
                            ></el-input-number>
                            <span v-else>{{item.userGetScoreValue ? item.userGetScoreValue : 0}}</span>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="answer-result" v-if="!$functions.isPC()">
                        <p>
                            <span class="title">结果：</span>
                            <span>{{item.isCorrect == 1 ? '正确': (item.isCorrect == 2 ? '错误': '错误')}}</span>
                        </p>
                        <p>
                            <span class="title">得分：</span>
                            <span>{{item.userGetScoreValue ? item.userGetScoreValue : 0}}</span>
                        </p>
                    </div>
                    <p class="answer" v-if="item.questionsTypeId != 209"><span class="title">正确答案：</span><span>{{item.correctAnswer}}</span></p>
                    <p class="analysis"><span class="title">解析：</span><span>{{item.analysis}}</span></p>
                </div>
            </div>
        </div>
        
        <div class="kong" v-if="data.length == 0">
            <img src="../../../assets/empty.png" alt="" />
            <p>暂无答卷</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnsweredPreview',
    props: {
        isPreview: { 
            type: Number, default: 0 
        },
        data: {
            type: Array, 
            default() {
                return []
            }
        },
    },
    watch: {
        'data': {
            handler(newV, oldV) {
                // console.log('监听')
                newV.forEach(info =>{
                    if (info.questionsTypeId == 208) {
                        let questionOption = [],
                        str = info.quesOptionTitle,
                        arr = str.match(/_[_]+_/g)
                        
                        for(let i in arr){
                            let obj = JSON.stringify({width:arr[i].length * 10,})
                            str = str.replace(arr[i],`^${obj}^`)
                        }
                        let arrData = str.split('^')
                        for(let i in arrData){
                            if(arrData[i]){
                                questionOption.push(this.$functions.isJSON(arrData[i]) ? JSON.parse(arrData[i]) : arrData[i])
                            }
                        }
                        let index = 0
                        questionOption = questionOption.map((info) =>{
                            if((typeof info) != 'string'){
                                info.index = index
                                index++
                            } else {
                                info = this.$functions.HTMLClosedOrNot(info)
                            }
                            return info
                        })
                        this.$set(info, 'questionOption', questionOption)
                    } else if (info.questionsTypeId == 210) {
                        if (info.userResult) info.userResult = info.userResult.split(',')
                    }
                })
            },
            immediate: true
        }
    },
    created() {
        this.data.forEach((info) => {
            info.correctAnswer = this.$functions.htmlFormat(info.correctAnswer)
            let type = ''
            switch(info.questionsTypeId){
                case 100:
                    type = '（单选题）'
                    break
                case 101:
                    type = '（多选题）'
                    break
                case 102:
                    type = '（判断题）'
                    break
                case 204:
                    type = '（填空题）'
                    break
                case 206:
                    type = '（简答题）'
                    break
                case 207:
                    type = '（多项填空）'
                    break
                case 208:
                    type = '（横向填空）'
                    break
                case 209:
                    type = '（绘图题）'
                    break
                case 210:
                    type = '（上传文件）'
                    break
                
            }
            
            info.questionsName = `${info.questionsName}${type}${info.score? `（${info.score}分）` : ''}`
            
        })
    },
    methods: {
        userGetScoreInput(item) {
            if (!item.userGetScoreValue) item.userGetScoreValue = 0
            if (parseFloat(item.userGetScoreValue) > 0) {
                item.isCorrect = 1
            }
        },
        exportFile(key) {
            let a = document.createElement('a')
            a.href = key
            a.download = key.split(':')[1] // 名字可自定义
            // console.log(a.download)
            a.click()
        }
    }
}
</script>

<style lang="scss" scoped>

.kong {
  width: 100%;
  background: #fff;
  margin: 0 auto;
text-align: center;
}
.kong img {
  width: 250px;
  height: 233px;
  margin-top: 100px;
  margin-left: 0;
}
.kong p {
  font-size: 20px;
  text-align: center;
  color: #999999;
  font-family: MicrosoftYahei;
  margin-top: 50px;
}
.submit{
    padding-top: 20px;
    text-align: center;
}
.list{
    // margin-top: 30px;
    position: relative;
    background-color: #fcfcfc;
    padding: 30px 39px;
    .label{
        position: absolute;
        left: 0;
        top: 12px;
        background-color: #169bd5;
        font-size: 13px;
        width: 27px;
        padding: 2px 5px;
        color: #fff;
    }
}
.user-info{
    margin-left: 30px;
    line-height: 40px;
    .user-info-text{
        display: inline-block;
        margin-left: 20px;
        font-size: 15px;
    }
}
.question{
    .top{
        display: flex;
        justify-content: space-between;
        .ques-body{
            width: 70%;
            .fileList-null{
                font-size: 14px;
                color: #999;
            }
            .fileList-box{
                display: block;
                margin-left: 0;
            }
            .img-box{
                line-height: 190px;
                text-align: center;
                background: #f7f8fa;
                font-size: 14px;
                color: #aaa;
                width: 438px;
                height: 190px;    
                border: 1px solid rgba(0, 0, 0, 0.1);
            }
            .optionList+.optionList{
                margin-top: 10px;
            }
            .optionList{
                margin-left: 10px;
                .title{
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                }
                .user-answer-item{
                    background-color: #f5f7f8;
                    font-size: 14px;
                    color: #A2A0A0;
                    padding: 10px;
                    box-sizing: border-box;
                }
            }
            .ques_content{
                font-size: 14px;
                line-height: 30px;

            }
            .input_box{
                display: inline-block;
            }
        }
        .title{
            display: flex;
            align-items: flex-start;
            margin-bottom: 10px;
            word-break: break-all;
            /deep/p:last-child{
                display: inline-block;
            }
        }
        .option-box{
            display: flex;
            flex-wrap: wrap;
            .option{
                display: flex;
                align-items: top;
                line-height: 30px;
                font-size: 14px;
                width: 100%;
                word-break: break-all;

                .option-index{
                    display: inline-block;
                    width: 25px;
                    height: 25px;
                    line-height: 25px;
                    text-align: center;
                    border-radius: 50%;
                    margin-right: 10px;
                    margin-top: 3px;
                }
                .option-action{
                    background-color:rgb(234, 240, 243);
                }
                .option-title{
                    display: inline-block;
                    width: 87%;
                }
            }
        }
        .user-answer{
            background-color: #f5f7f8;
            font-size: 14px;
            color: #A2A0A0;
            padding: 10px;
            box-sizing: border-box;
        }
        /deep/.el-button--primary{
            border-color: #fff;
            background-color: #f3f3f3;
            color:#999;
        }
        .result{
            display: flex;
            flex-direction: column;
            .score{
                margin-top: 20px;
                font-size: 14px;
                color: #999999;
            }
            /deep/.el-button-group{
                display: flex;
                justify-content: flex-end;
            }
            // .input{
                
            //     width: 70px;
            // }
        }
        
        .correct{
            background-color: #67C23A;
            color:#fff;
        }
        .error{
            background-color: #F56C6C;
            color:#fff;
        }
    }
    .bottom{
        margin-top: 30px;
        .answer, .answer-result{
            background-color: #f5f7f8;
            line-height: 36px;
            font-size: 14px;
            padding: 0 20px;
        }
        .answer-result+.answer{
            margin-top: 10px;
        }
        .analysis{
            display: flex;
            margin-top: 20px;                            
            background-color: #f5f7f8;
            line-height: 36px;
            font-size: 14px;
            padding: 0 20px;
            .title{
                color: #6B828C;
                display: flex;
                align-items: center;
            }
            .title::before{
                content: '';
                margin-right: 5px;
                display: inline-block;
                width: 5px;
                height: 22px;
                background-color: rgba(188, 208, 217, 1);
            }
        }
    }
}
.other-input{
    width: 80px;
    margin-left: 10px;
    
}
.other-input /deep/.el-input--mini .el-input__inner{
  height: 22px;
  line-height: 22px;
}
input:disabled {
    background: rgba(240, 240, 240, 0);
}
</style>